(function () {
  window.dataLayer = window.dataLayer || [];

  function getCurrencyCode() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'JPY';
  }

  // ------------------------------------------------------------------------
  // (2) client_idをカート属性へ同期(チェックアウト側ピクセルへの引き継ぎ用)
  //     ここは本物のCookieにアクセスできるので、_ga Cookieから素直に抽出できる。
  // ------------------------------------------------------------------------
  function extractGA4ClientId() {
    var cookieString = document.cookie;
    var gaMatch = cookieString.match(/_ga=GA1\.[0-9]\.([0-9]+\.[0-9]+)/);
    return gaMatch && gaMatch[1] ? gaMatch[1] : "";
  }

  function syncClientIdToCartAttributes() {
    var clientId = extractGA4ClientId();
    if (!clientId) {
      return false; // gtag.jsがまだ_gaを発行していない
    }

    var lastSynced = window.sessionStorage.getItem("ga4_client_id_last_synced");
    if (lastSynced === clientId) {
      return true;
    }

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { ga_client_id: clientId } }),
      keepalive: true
    }).then(function () {
      window.sessionStorage.setItem("ga4_client_id_last_synced", clientId);
    }).catch(function (err) {
      console.warn("GA4 client_id sync to cart attributes failed:", err);
    });

    return true;
  }

  (function retrySync() {
    var attempts = 0;
    var maxAttempts = 10;
    var intervalId = setInterval(function () {
      attempts++;
      if (syncClientIdToCartAttributes() || attempts >= maxAttempts) {
        clearInterval(intervalId);
      }
    }, 500);
  })();

  // ------------------------------------------------------------------------
  // (3) page_view(全ページ共通)
  //     page_location/page_referrerは本物のwindow/documentの値をそのまま使えばよい
  //     (サンドボックスではないので上書き不要)。
  // ------------------------------------------------------------------------
  window.dataLayer.push({
    event: 'page_view',
    page_location: window.location.href,
    page_title: document.title,
    page_referrer: document.referrer
  });

  // ------------------------------------------------------------------------
  // (4) view_item(商品ページ)
  //     product-data.liquid が出力した
  //     <script type="application/json" id="ga4-product-data"> を読み取る
  // ------------------------------------------------------------------------
  (function pushViewItem() {
    var dataEl = document.getElementById('ga4-product-data');
    if (!dataEl) return; // 商品ページ以外では何もしない

    try {
      var product = JSON.parse(dataEl.textContent);
      window.dataLayer.push({
        event: 'view_item',
        page_location: window.location.href,
        page_referrer: document.referrer,
        ecommerce: {
          currency: product.currency || getCurrencyCode(),
          value: product.price,
          items: [{
            item_id: product.sku || product.id,
            item_name: product.title,
            price: product.price,
            quantity: 1,
            item_variant: product.variant_title
          }]
        }
      });
    } catch (e) {
      console.warn('view_item dataLayer push failed:', e);
    }
  })();

  // ------------------------------------------------------------------------
  // 共通: カート情報の整形・取得
  // ------------------------------------------------------------------------
  function formatCartItems(items) {
    return (items || []).map(function (item) {
      return {
        item_id: item.sku || item.variant_id,
        item_name: item.product_title || item.title,
        price: (item.price || 0) / 100,
        quantity: item.quantity,
        item_variant: item.variant_title || ''
      };
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function pushViewCart(cart) {
    window.dataLayer.push({
      event: 'view_cart',
      page_location: window.location.href,
      page_referrer: document.referrer,
      ecommerce: {
        currency: getCurrencyCode(),
        value: (cart.total_price || 0) / 100,
        items: formatCartItems(cart.items)
      }
    });
  }

  function pushAddToCart(addedItems) {
    if (!addedItems || !addedItems.length) return;
    window.dataLayer.push({
      event: 'add_to_cart',
      page_location: window.location.href,
      page_referrer: document.referrer,
      ecommerce: {
        currency: getCurrencyCode(),
        value: addedItems.reduce(function (sum, i) { return sum + ((i.price || 0) / 100) * i.quantity; }, 0),
        items: formatCartItems(addedItems)
      }
    });
  }

  // ------------------------------------------------------------------------
  // (5) カートの初期スナップショット取得
  //     - カートページなら view_cart をそのまま送信
  //     - 以後の add_to_cart 検知の比較基準として保持
  // ------------------------------------------------------------------------
  var lastCartSnapshot = null;

  function snapshotKey(item) {
    return item.variant_id + '|' + JSON.stringify(item.properties || {});
  }

  fetchCart().then(function (cart) {
    lastCartSnapshot = cart;
    if (window.location.pathname.indexOf('/cart') === 0) {
      pushViewCart(cart);
    }
  }).catch(function (err) {
    console.warn('Initial cart snapshot fetch failed:', err);
  });

  // ------------------------------------------------------------------------
  // (6) add_to_cart
  //     customize.js 内で使われている `subscribe(PUB_SUB_EVENTS.cartUpdate, ...)`
  //     (Dawn系テーマ標準のPub/Sub)を利用してカート更新を検知する。
  //     カート更新のたびに最新の /cart.js を取得し、直前のスナップショットと
  //     数量を比較して増加分だけを add_to_cart として送信する
  //     (数量減少=削除はここでは扱わない)。
  // ------------------------------------------------------------------------
  function diffAndPushAddToCart(newCart) {
    if (!lastCartSnapshot) {
      lastCartSnapshot = newCart;
      return;
    }

    var previousQuantities = {};
    (lastCartSnapshot.items || []).forEach(function (item) {
      previousQuantities[snapshotKey(item)] = item.quantity;
    });

    var addedItems = [];
    (newCart.items || []).forEach(function (item) {
      var key = snapshotKey(item);
      var previousQuantity = previousQuantities[key] || 0;
      var delta = item.quantity - previousQuantity;
      if (delta > 0) {
        addedItems.push(Object.assign({}, item, { quantity: delta }));
      }
    });

    lastCartSnapshot = newCart;

    if (addedItems.length) {
      pushAddToCart(addedItems);
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetchCart().then(diffAndPushAddToCart).catch(function (err) {
        console.warn('Cart update fetch failed:', err);
      });
    });
  } else {
    console.warn(
      'PUB_SUB_EVENTS.cartUpdate が見つかりません。add_to_cart の自動検知が無効になっています。' +
      'window.subscribe / window.PUB_SUB_EVENTS がこのテーマで定義されているか確認してください。'
    );
  }
})();
